export default "__VITE_ASSET__BO40Zdm2__"